export const GET_MAIN_SHAFT_UNBALANCE_RESULT = "GET_MAIN_SHAFT_UNBALANCE_RESULT";
export const GET_MAIN_SHAFT_UNBALANCE_RESULT_SUCCESS = "GET_MAIN_SHAFT_UNBALANCE_RESULT_SUCCESS";
export const GET_MAIN_SHAFT_UNBALANCE_RESULT_ERROR = "GET_MAIN_SHAFT_UNBALANCE_RESULT_ERROR";
export const RESET_MAIN_SHAFT_UNBALANCE_RESULT = "RESET_MAIN_SHAFT_UNBALANCE_RESULT";
export const GET_MAIN_SHAFT_UNBALANCE_CHART = "GET_MAIN_SHAFT_UNBALANCE_CHART";
export const GET_MAIN_SHAFT_UNBALANCE_CHART_SUCCESS = "GET_MAIN_SHAFT_UNBALANCE_CHART_SUCCESS";
export const GET_MAIN_SHAFT_UNBALANCE_CHART_ERROR = "GET_MAIN_SHAFT_UNBALANCE_CHART_ERROR";
